export enum Topic {
    CTC_QUEUE_METRICS_DATA = '/user/topic/v1/queue-metrics',
    REQUEST_USER_STATUS = '/user/topic/v1/request-user-status',
    CALL_ALERT_UPDATE = '/user/topic/v1/call-alert/update',
    UI_LOG_STREAMING_NEW = '/user/topic/v1/ui-logging/new',
    UI_LOG_STREAMING_EDIT = '/user/topic/v1/ui-logging/edit',
    UI_LOG_STREAMING_UPDATE = '/user/topic/v1/ui-logging/update',
    UI_LOG_STREAMING_DELETE = '/user/topic/v1/ui-logging/delete',
    CALL_ALERT_NEW = '/user/topic/v1/call-alert/new',
    CALL_ALERT_DELETE = '/user/topic/v1/call-alert/delete',
    QUIESCENCE = '/topic/v1/node-quiesced',
    CALL_NEW = `/user/topic/v1/call/new`,
    CALL_EDIT = `/user/topic/v1/call/*/edit`,
    CALL_DELETE = `/user/topic/v1/call/*/delete`,
    ANNOUNCEMENT_MESSAGE_NEW = '/user/topic/v1/announcement/new',
    REMOTE_CALL = `/user/topic/v1/linked-call`,
    PEER_PASSWORD_REVOKED = `/user/topic/v1/call/asterisk/password/revoke`,
    IM_MESSAGE_NEW = '/user/topic/v1/instant-message/new',
    SYNC_SERVER_TIME = `/topic/sync-server-time`,
    USER_AUTHENTICATION_NEW = `/user/topic/v1/user-auth/new`,
    USER_AUTHENTICATION_EDIT = `/user/topic/v1/user-auth/*/edit`,
    USER_AUTHENTICATION_DELETE = `/user/topic/v1/user-auth/*/delete`,
    LOCATION = `/user/topic/v1/call/location`,
    ACD_REVOKE = `/user/topic/v1/acd/*/revoke`,
    APPLICATION = `/user/topic/v1/app/CallStationNM`,
    CALL_STATION_LOCAL = `/user/topic/v1/app/CallStationLocal`,
    USER_LOGOUT = `/user/topic/v1/tpi-auth/logout`,
    MESSAGES_DTMF_NEW = '/user/topic/v1/message/DTMF/new',
    MESSAGES_DTMF_EDIT = '/user/topic/v1/message/DTMF/*/edit',
    MESSAGES_DTMF_DELETE = '/user/topic/v1/message/DTMF/*/delete',
    MESSAGES_RTT_NEW = '/user/topic/v1/message/RTT/new',
    MESSAGES_RTT_EDIT = '/user/topic/v1/message/RTT/*/edit',
    MESSAGES_RTT_DELETE = '/user/topic/v1/message/RTT/*/delete',
    MESSAGES_SMS_NEW = '/user/topic/v1/message/SMS/new',
    MESSAGES_SMS_EDIT = '/user/topic/v1/message/SMS/*/edit',
    MESSAGES_SMS_DELETE = '/user/topic/v1/message/SMS/*/delete',
    MESSAGES_TDD_NEW = '/user/topic/v1/message/TDD/new',
    MESSAGES_TDD_EDIT = '/user/topic/v1/message/TDD/*/edit',
    MESSAGES_TDD_DELETE = '/user/topic/v1/message/TDD/*/delete',
    MESSAGES_SYSTEM_ERROR_NEW = '/user/topic/v1/message/SYSTEM_ERROR/new',
    MESSAGES_SYSTEM_ERROR_EDIT = '/user/topic/v1/message/SYSTEM_ERROR/edit',
    MESSAGES_SYSTEM_ERROR_DELETE = '/user/topic/v1/message/SYSTEM_ERROR/delete',
    MESSAGES_SYSTEM_NEW = '/user/topic/v1/message/SYSTEM/new',
    MESSAGES_SYSTEM_EDIT = '/user/topic/v1/message/SYSTEM/edit',
    MESSAGES_SYSTEM_DELETE = '/user/topic/v1/message/SYSTEM/delete',
    FORCED_LOGOUT = '/user/topic/v1/forced-logout'
}


export type MultipleSubscriptions = {
    [clusterName: string]: {
        [key in Topic]?: {
            [receipt: string]: boolean
        }
    }
}


export type MultipleSubscriptionsStatus = {
    [clusterName: string]: {
        [key in Topic]?: boolean
    }
}
